import * as wjcCore from 'wijmo/wijmo';
// angular
import {Injectable} from '@angular/core';

// libs
import {Store, Action} from '@ngrx/store';
import {Effect, Actions, ofType} from '@ngrx/effects';
import {map, switchMap} from 'rxjs/internal/operators';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/switchMap';

import {LotasConfig} from '../../config/lotas.config';

// module
import {DataService} from '@cosbeni/database';
import {ActionTypes, LoadConfigurationSuccessAction, LoadConfigurationFailureAction} from '../actions/configuration.action';

@Injectable()
export class ConfigurationEffects {

    @Effect() loadConfiguration$: Observable<Action> = this.actions$.pipe(
        ofType(ActionTypes.LOAD_CONFIGURATION),
        switchMap((state: any) => {
            return this.dataService.query({
                sql: 'SELECT FROM LOTAS_Configuration WHERE state = \'' + state.payload + '\' AND fiscal = 0',
                fetchPlan: '*:0',
            }, LotasConfig.SERVER_URL).map((data) => {
                let configuration: any = {};
                for (let item of data.results) {
                    configuration[item.name] = this.getValue(item.value);
                }
                return new LoadConfigurationSuccessAction(configuration);
            }).catch(() => {
                    return Observable.of(new LoadConfigurationFailureAction());
                }
            );
        })
    );

    constructor(private store: Store<any>,
                private actions$: Actions,
                private dataService: DataService) {
    }

    getValue(data: any) {
        if (wjcCore.isString(data)) {
            let num = data.replace(/,/g, '');
            if (!isNaN(parseInt(num)) && wjcCore.isNumber(parseInt(num))) {
                return parseInt(num);
            }
            try {
                let o = '{"dummy":' + data + '}';
                let d = JSON.parse(o);
                return d["dummy"];
            } catch (e) {
                return data;
            }
        }
        if (wjcCore.isNumber(data)) {
            return data;
        }
        return data;
    }
}

